var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPencilWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPencilWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0574838,3.37409353 L14.4930658,6.82646863 L5.79665898,15.5654646 L2.3630248,12.1130895 L11.0574838,3.37409353 Z M17.1000081,2.54145981 L15.5678707,1.00181905 C14.9757525,0.406801056 14.0142749,0.406801056 13.420145,1.00181905 L11.9525106,2.47664094 L15.3880926,5.92904813 L17.1000081,4.20874883 C17.5592566,3.7472192 17.5592566,3.00295735 17.1000081,2.54145981 Z M0.56511597,16.9656806 C0.502592783,17.2484449 0.756645118,17.5018161 1.03806332,17.4330503 L4.86644297,16.5002682 L1.43280879,13.0478931 L0.56511597,16.9656806 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup---quick-msg---select-template",
    transform: "translate(-345.000000, -236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QUICK-MESSAGE",
    transform: "translate(317.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/buttons/pill",
    transform: "translate(17.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPencilWhite",
    transform: "translate(11.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#8B8B8B",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.000000, -11.000000)",
    id: "colour/light-grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 40 0 40 40 0 40"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencilWhite);
export default __webpack_public_path__ + "static/media/icPencilWhite.c26ec94dc7719ab0c368c35262e33294.svg";
export { ForwardRef as ReactComponent };